// « Demander le paiement » (2026-10-14) — components/admin/PaymentRequestModal.tsx,
// in the conversation header and on the order page. French string → English.
const m: Record<string, string> = {
  'Demander le paiement': 'Request payment',
  'Demande envoyée': 'Request sent',
  'Envoyée': 'Sent',
  'Paiement': 'Payment',
  'Langue de la cliente': 'Client language',
  'inconnue': 'unknown',
  'Français': 'French',
  'Arabe': 'Arabic',
  'Darija': 'Darija',
  'Anglais': 'English',
  'Version darija pas encore écrite — message en français': 'Darija version not written yet — message in French',
  'Préparation du message…': 'Preparing the message…',
  'Le bouton est désactivé dans les réglages — aperçu seulement.': 'The button is switched off in settings — preview only.',
  'Envoi impossible': 'Cannot send',
  'Total de la commande': 'Order total',
  'Verrouillé': 'Locked',
  'Début du message': 'Message opening',
  'Fin du message': 'Message closing',
  'Les montants et le RIB viennent de la commande et ne se modifient pas ici. L’assistant reste actif pour répondre à ses questions.':
    'Amounts and bank details come from the order and cannot be edited here. The assistant stays on to answer her questions.',
  'Rouvrir l’aperçu': 'Reopen the preview',
  'Envoi…': 'Sending…',
  'Envoyer': 'Send',
};
export default m;
